export interface ISystemRecentPoints {
    pointIds: String;
}

export class SystemRecentPoints implements ISystemRecentPoints {
    pointIds: String;
    constructor(pointIds: String) {
        this.pointIds = pointIds;
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemHealthRetriever/system-recent-points.ts
 **/